module.exports = __webpack_public_path__ + "static/media/remove_person.ac00f38e.svg";